import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="faqs"
export default class extends Controller {
  
  static targets = ['text', 'span'];
  
  connect() {
  }
  
  toggle() {
    this.spanTarget.classList.toggle('open');
    this.textTarget.classList.toggle('open');
  }
}
